import React from 'react';
import { Box, TextField, InputAdornment, IconButton, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon, ViewModule as GridIcon, ViewList as ListIcon } from '@mui/icons-material';

function BookListControls({ 
  searchTerm, 
  onSearchChange, 
  onClearSearch, 
  viewMode, 
  onViewModeChange, 
  filteredBooks, 
  userCurrency 
}) {
  return (
    <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
      <TextField
        placeholder="Search books..."
        value={searchTerm}
        onChange={onSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: searchTerm && (
            <InputAdornment position="end">
              <IconButton onClick={onClearSearch} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
        sx={{ minWidth: 300, flexGrow: 1 }}
      />
      
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={(e, newMode) => newMode && onViewModeChange(newMode)}
        size="small"
      >
        <ToggleButton value="grid">
          <GridIcon />
        </ToggleButton>
        <ToggleButton value="list">
          <ListIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default BookListControls; 